import { TRAVEL_HOTEL_SUPPLIERS } from 'app.config';
import * as fromActions from '../actions/hotel-suppliers.actions';
import { HotelSupplierActions } from '../actions/hotel-suppliers.actions';

export type SupplierInfo = { [id: string]: boolean };
export const initialState: SupplierInfo = null;

export function reducer(state = initialState, action: HotelSupplierActions): SupplierInfo {
  switch (action.type) {
    case fromActions.GET_HOTEL_SUPPLIERS_SUCCESS:
      localStorage.setItem(TRAVEL_HOTEL_SUPPLIERS, JSON.stringify(action.payload));
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}

export const getHotelSuppliers = (state: SupplierInfo) => state;
